<template>
  <v-card class="mb-4 budget-header px-5 py-3">
    <v-row align="center" justify="space-between" no-gutters>
      <v-col cols="auto">
        <v-btn 
          fab 
          small 
          elevation="0" 
          color="#E8EBEE"
          @click="selectPreviousBudget" 
          :disabled="!hasPreviousBudget"
          class="navigation-btn"
        >
          <v-icon color="#5C616F">mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
      
      <v-col class="text-center">
        <span class="text-subtitle-1 font-weight-medium">
          {{ currentBudget ? currentBudget.name : 'Loading...' }}
        </span>
      </v-col>
      
      <v-col cols="auto">
        <v-btn 
          fab 
          small 
          elevation="0" 
          color="#E8EBEE"
          @click="selectNextBudget" 
          :disabled="!hasNextBudget"
          class="navigation-btn"
        >
          <v-icon color="#5C616F">mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'BudgetHeader',
  
  props: {
    currentBudget: {
      type: Object,
      required: true
    },
    budgets: {
      type: Array,
      required: true
    }
  },

  computed: {
    currentBudgetIndex() {
      return this.budgets.findIndex(budget => budget.id === this.currentBudget.id);
    },
    hasPreviousBudget() {
      return this.currentBudgetIndex > 0;
    },
    hasNextBudget() {
      return this.currentBudgetIndex < this.budgets.length - 1;
    }
  },

  methods: {
    selectPreviousBudget() {
      if (this.hasPreviousBudget) {
        const previousBudget = this.budgets[this.currentBudgetIndex - 1];
        this.$emit('budget-selected', previousBudget);
      }
    },
    selectNextBudget() {
      if (this.hasNextBudget) {
        const nextBudget = this.budgets[this.currentBudgetIndex + 1];
        this.$emit('budget-selected', nextBudget);
      }
    }
  }
}
</script>

<style scoped>
.budget-header {
  background-color: white !important;
  border-radius: 16px !important;
  box-shadow: 0px 16px 64px -32px rgba(0, 0, 0, 0.24) !important;
}

.navigation-btn.v-btn--disabled {
  background-color: #F6F7F8 !important;
}

.navigation-btn.v-btn--disabled .v-icon {
  color: #B4B7C1 !important;
}
</style>
